export default function DSocial({ className }) {
    return (
        <svg className={className} width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.438 0.75C6.054 0.75 0.8745 5.7855 0.8745 12C0.8745 13.6635 1.242 15.243 1.914 16.665L0 21.231L4.9605 20.5815C6.9765 22.245 9.5865 23.25 12.438 23.25C18.828 23.25 24 18.2145 24 12C24 5.7855 18.828 0.75 12.438 0.75ZM18.75 11.967C18.75 15.4275 16.4265 18 12.4515 18H8.25V6H12.5115C16.4565 6 18.75 8.4765 18.75 11.9355V11.967Z" fill="currentColor" />
            <path d="M12.5565 8.94299H11.3115V15.048H12.5565C14.3895 15.048 15.6045 13.9515 15.6045 12.0075V11.976C15.6045 10.056 14.3895 8.94299 12.5565 8.94299Z" fill="currentColor" />
        </svg>
    );
}
